/* Généré depuis figaret-checkout-extensions/shared/offers.ts : ne pas éditer à la main (npm run build:theme-shared). */
var OffersShared = (() => {
  var __defProp = Object.defineProperty;
  var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
  var __getOwnPropNames = Object.getOwnPropertyNames;
  var __hasOwnProp = Object.prototype.hasOwnProperty;
  var __export = (target, all) => {
    for (var name in all)
      __defProp(target, name, { get: all[name], enumerable: true });
  };
  var __copyProps = (to, from, except, desc) => {
    if (from && typeof from === "object" || typeof from === "function") {
      for (let key of __getOwnPropNames(from))
        if (!__hasOwnProp.call(to, key) && key !== except)
          __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
    }
    return to;
  };
  var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

  // shared/offers.ts
  var offers_exports = {};
  __export(offers_exports, {
    DECLINED_OFFERS_ATTRIBUTE: () => DECLINED_OFFERS_ATTRIBUTE,
    GIFT_PRODUCT_TYPE: () => GIFT_PRODUCT_TYPE,
    OFFERS_DOCUMENT_VERSION: () => OFFERS_DOCUMENT_VERSION,
    OFFER_LINE_PROPERTY: () => OFFER_LINE_PROPERTY,
    collectionLines: () => collectionLines,
    effectiveOfferHandle: () => effectiveOfferHandle,
    eligibleQuantity: () => eligibleQuantity,
    eligibleTotal: () => eligibleTotal,
    evaluateCondition: () => evaluateCondition,
    findOffer: () => findOffer,
    hasAnyCriterion: () => hasAnyCriterion,
    isConditionEvaluable: () => isConditionEvaluable,
    isExcludedFromTotal: () => isExcludedFromTotal,
    isGiftLine: () => isGiftLine,
    isGiftOfOffer: () => isGiftOfOffer,
    isGiftTypeLine: () => isGiftTypeLine,
    isOfferPublished: () => isOfferPublished,
    minimumLines: () => minimumLines,
    minimumTotal: () => minimumTotal,
    numericId: () => numericId,
    parseDeclinedOffers: () => parseDeclinedOffers,
    parseOffersDocument: () => parseOffersDocument,
    pickThreshold: () => pickThreshold,
    resolveLineOffer: () => resolveLineOffer,
    resolveThreshold: () => resolveThreshold,
    sameId: () => sameId,
    serializeDeclinedOffers: () => serializeDeclinedOffers
  });
  var OFFERS_DOCUMENT_VERSION = 1;
  var GIFT_PRODUCT_TYPE = "gift";
  var OFFER_LINE_PROPERTY = "_offer";
  var DECLINED_OFFERS_ATTRIBUTE = "_offers_declined";
  function parseOffersDocument(value) {
    if (!value)
      return null;
    let doc = value;
    if (typeof value === "string") {
      try {
        doc = JSON.parse(value);
      } catch {
        return null;
      }
    }
    if (!doc || typeof doc !== "object")
      return null;
    const candidate = doc;
    if (candidate.version !== OFFERS_DOCUMENT_VERSION || !Array.isArray(candidate.offers)) {
      return null;
    }
    return candidate;
  }
  function numericId(gid) {
    const index = gid.lastIndexOf("/");
    return index === -1 ? gid : gid.slice(index + 1);
  }
  function sameId(a, b) {
    return a === b || numericId(a) === numericId(b);
  }
  function isGiftTypeLine(line) {
    return line.productType === GIFT_PRODUCT_TYPE;
  }
  function isGiftLine(line) {
    return isGiftTypeLine(line) && !!line.offerHandle;
  }
  function resolveLineOffer(doc, line) {
    var _a;
    if (!doc || !isGiftTypeLine(line))
      return void 0;
    if (line.offerHandle) {
      const offer = findOffer(doc, line.offerHandle);
      return offer && isGiftOfOffer(offer, line.variantId) ? offer : void 0;
    }
    return (_a = doc.offers.find((offer) => offer.status === "active" && isGiftOfOffer(offer, line.variantId))) != null ? _a : doc.offers.find((offer) => isGiftOfOffer(offer, line.variantId));
  }
  function effectiveOfferHandle(doc, line) {
    var _a, _b, _c;
    return (_c = (_b = line.offerHandle) != null ? _b : (_a = resolveLineOffer(doc, line)) == null ? void 0 : _a.handle) != null ? _c : null;
  }
  function parseDeclinedOffers(value) {
    if (!value)
      return [];
    return value.split(",").map((handle) => handle.trim()).filter(Boolean);
  }
  function serializeDeclinedOffers(handles) {
    return Array.from(new Set(handles.filter(Boolean))).join(",");
  }
  function isOfferPublished(offer, snapshot) {
    var _a, _b;
    if (offer.status !== "active")
      return false;
    const now = snapshot.now.getTime();
    const dayGranularity = snapshot.timeGranularity === "day";
    if (offer.publicationStart) {
      const start = new Date(offer.publicationStart).getTime();
      if (!Number.isNaN(start)) {
        const bound = dayGranularity ? startOfUtcDay(start) : start;
        if (now < bound)
          return false;
      }
    }
    if (offer.publicationEnd) {
      const end = new Date(offer.publicationEnd).getTime();
      if (!Number.isNaN(end)) {
        const bound = dayGranularity ? endOfUtcDay(end) : end;
        if (now > bound)
          return false;
      }
    }
    const country = (_b = (_a = snapshot.countryCode) == null ? void 0 : _a.toUpperCase()) != null ? _b : null;
    const included = offer.countriesIncluded.map((c) => c.toUpperCase());
    const excluded = offer.countriesExcluded.map((c) => c.toUpperCase());
    if (included.length > 0 && (!country || !included.includes(country)))
      return false;
    if (country && excluded.includes(country))
      return false;
    return true;
  }
  function startOfUtcDay(ms) {
    const d = new Date(ms);
    return Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
  }
  function endOfUtcDay(ms) {
    return startOfUtcDay(ms) + 24 * 60 * 60 * 1e3 - 1;
  }
  function isExcludedFromTotal(offer, line) {
    if (line.isGiftCard)
      return true;
    if (isGiftTypeLine(line))
      return true;
    return offer.excludedProductIds.some((id) => sameId(id, line.productId));
  }
  function eligibleTotal(offer, snapshot) {
    const excluded = snapshot.lines.filter((line) => isExcludedFromTotal(offer, line)).reduce((sum, line) => sum + line.amount, 0);
    if (snapshot.cartTotal !== void 0 && snapshot.cartTotal !== null) {
      return Math.max(0, snapshot.cartTotal - excluded);
    }
    const all = snapshot.lines.reduce((sum, line) => sum + line.amount, 0);
    return Math.max(0, all - excluded);
  }
  function eligibleQuantity(offer, snapshot) {
    return snapshot.lines.filter((line) => !isExcludedFromTotal(offer, line)).reduce((sum, line) => sum + line.quantity, 0);
  }
  function pickThreshold(offer, snapshot) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i;
    const thresholds = (_a = offer.condition.thresholds) != null ? _a : [];
    const country = (_c = (_b = snapshot.countryCode) == null ? void 0 : _b.toUpperCase()) != null ? _c : null;
    const market = (_e = (_d = snapshot.marketHandle) == null ? void 0 : _d.toLowerCase()) != null ? _e : null;
    const currency = snapshot.currencyCode.toUpperCase();
    const pick = (scope, key) => thresholds.find(
      (t) => {
        var _a2;
        return t.scope === scope && (scope === "global" || ((_a2 = t.key) != null ? _a2 : "").trim().toLowerCase() === (key != null ? key : "").toLowerCase());
      }
    );
    return (_i = (_h = (_g = (_f = country ? pick("country", country) : void 0) != null ? _f : market ? pick("market", market) : void 0) != null ? _g : pick("currency", currency)) != null ? _h : pick("global", null)) != null ? _i : null;
  }
  function resolveThreshold(offer, snapshot) {
    const threshold = pickThreshold(offer, snapshot);
    if (!threshold)
      return null;
    if (threshold.scope === "currency")
      return parseAmount(threshold.amount);
    const needsConversion = !!snapshot.shopCurrencyCode && snapshot.shopCurrencyCode.toUpperCase() !== snapshot.currencyCode.toUpperCase();
    if (snapshot.currencyRate === null) {
      return needsConversion ? "unknown" : parseAmount(threshold.amount);
    }
    return toCartCurrency(threshold.amount, snapshot.currencyRate);
  }
  function parseAmount(value) {
    const parsed = parseFloat(String(value).replace(",", "."));
    return Number.isNaN(parsed) ? 0 : parsed;
  }
  function toCartCurrency(amount, rate) {
    const safeRate = Number.isFinite(rate) && rate > 0 ? rate : 1;
    return parseAmount(amount) * safeRate;
  }
  function collectionLines(offer, snapshot) {
    var _a;
    const base = snapshot.lines.filter((line) => !isExcludedFromTotal(offer, line));
    const collections = (_a = offer.condition.collectionIds) != null ? _a : [];
    if (collections.length === 0)
      return base;
    if (base.some((line) => line.collectionIds === null))
      return "unknown";
    return base.filter((line) => collections.some((id) => {
      var _a2;
      return ((_a2 = line.collectionIds) != null ? _a2 : []).some((c) => sameId(c, id));
    }));
  }
  function minimumLines(offer, snapshot) {
    var _a, _b;
    const base = snapshot.lines.filter((line) => !isExcludedFromTotal(offer, line));
    const condition = offer.condition;
    const collections = (_a = condition.collectionIds) != null ? _a : [];
    const variants = (_b = condition.variantIds) != null ? _b : [];
    if (!condition.scopedMinimums || collections.length === 0 && variants.length === 0)
      return base;
    const byVariant = base.filter((line) => variants.some((id) => sameId(id, line.variantId)));
    if (collections.length === 0)
      return byVariant;
    const byCollection = collectionLines(offer, snapshot);
    if (byCollection === "unknown")
      return "unknown";
    const keys = new Set(byCollection.map((line) => line.variantId));
    return base.filter((line) => keys.has(line.variantId) || byVariant.includes(line));
  }
  function minimumTotal(offer, snapshot) {
    var _a, _b;
    const condition = offer.condition;
    const scoped = !!condition.scopedMinimums && (((_a = condition.collectionIds) != null ? _a : []).length > 0 || ((_b = condition.variantIds) != null ? _b : []).length > 0);
    if (!scoped)
      return eligibleTotal(offer, snapshot);
    const lines = minimumLines(offer, snapshot);
    if (lines === "unknown")
      return "unknown";
    return lines.reduce((sum, line) => sum + line.amount, 0);
  }
  function hasAnyCriterion(condition) {
    var _a, _b, _c, _d, _e;
    return ((_a = condition.thresholds) != null ? _a : []).length > 0 || ((_b = condition.variantIds) != null ? _b : []).length > 0 || ((_c = condition.collectionIds) != null ? _c : []).length > 0 || ((_d = condition.minimumQuantity) != null ? _d : 0) > 0 || ((_e = condition.customerTags) != null ? _e : []).length > 0;
  }
  function evaluateCondition(offer, snapshot) {
    var _a, _b, _c, _d, _e, _f;
    const condition = offer.condition;
    if (!hasAnyCriterion(condition))
      return "unmet";
    let unknown = false;
    if (((_a = condition.collectionIds) != null ? _a : []).length > 0) {
      const lines = collectionLines(offer, snapshot);
      if (lines === "unknown")
        unknown = true;
      else if (lines.length === 0)
        return "unmet";
    }
    if (((_b = condition.thresholds) != null ? _b : []).length > 0) {
      const threshold = resolveThreshold(offer, snapshot);
      if (threshold === null)
        return "unmet";
      if (threshold === "unknown") {
        unknown = true;
      } else {
        const total = minimumTotal(offer, snapshot);
        if (total === "unknown")
          unknown = true;
        else if (total < threshold)
          return "unmet";
      }
    }
    if (((_c = condition.minimumQuantity) != null ? _c : 0) > 0) {
      const lines = minimumLines(offer, snapshot);
      if (lines === "unknown")
        unknown = true;
      else if (lines.reduce((sum, line) => sum + line.quantity, 0) < ((_d = condition.minimumQuantity) != null ? _d : 0))
        return "unmet";
    }
    if (((_e = condition.variantIds) != null ? _e : []).length > 0) {
      const required = condition.variantIds;
      const inCart = (variantId) => snapshot.lines.some((line) => !isGiftTypeLine(line) && sameId(line.variantId, variantId));
      const ok = condition.matchAll ? required.every(inCart) : required.some(inCart);
      if (!ok)
        return "unmet";
    }
    if (((_f = condition.customerTags) != null ? _f : []).length > 0) {
      const tags = condition.customerTags.map((t) => t.trim().toLowerCase()).filter(Boolean);
      if (snapshot.customerTags === null) {
        unknown = true;
      } else {
        const owned = snapshot.customerTags.map((t) => t.trim().toLowerCase());
        if (!tags.some((t) => owned.includes(t)))
          return "unmet";
      }
    }
    return unknown ? "unknown" : "met";
  }
  function isConditionEvaluable(offer, snapshot) {
    return evaluateCondition(offer, snapshot) !== "unknown";
  }
  function isGiftOfOffer(offer, variantId) {
    return offer.gifts.some((gift) => sameId(gift.variantId, variantId));
  }
  function findOffer(doc, handle) {
    if (!doc || !handle)
      return void 0;
    return doc.offers.find((offer) => offer.handle === handle);
  }
  return __toCommonJS(offers_exports);
})();
